import { Routes, Route } from "react-router";
import { LandingPage } from "@/pages/LandingPage";
import { TermsPage } from "@/pages/legal/TermsPage";
import { PrivacyPage } from "@/pages/legal/PrivacyPage";
import { PortfolioNoticePage } from "@/pages/PortfolioNoticePage";

function App() {
  return (
    <Routes>
      {/* Landing page — the only interactive artifact of the open-source vitrine */}
      <Route index element={<LandingPage />} />

      {/* Legal pages — public, LGPD compliance (kept from when app was commercial) */}
      <Route path="/termos" element={<TermsPage />} />
      <Route path="/privacidade" element={<PrivacyPage />} />

      {/* All other routes (/admin/*, /dashboard/*, /login, etc.) — app is
          no longer deployed; redirect to GitHub notice. */}
      <Route path="*" element={<PortfolioNoticePage />} />
    </Routes>
  );
}

export default App;
